










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class PlayerRowSkelton extends Vue {
  @Prop() readonly rowsNum!: string;
  rowIterateNumber = 0;
  defaultRowNumber = 3;

  created() {
    this.rowIterateNumber = this.rowsNum
      ? Number(this.rowsNum)
      : this.defaultRowNumber;
  }
}
